import ClaimantInfo from "./ClaimantInfo";

export default ClaimantInfo;
